<template>
  <div class="sns">
    <a
      v-if="snsURL?.homepage"
      class="sns-icon home"
      :href="snsURL?.homepage"
      target="_blank"
    >
      <inline-svg :src="require('@/assets/img/icon/home.svg')" />
    </a>
    <a
      v-if="snsURL?.instagram"
      class="sns-icon instagram"
      :href="snsURL?.instagram"
      target="_blank"
    >
      <inline-svg :src="require('@/assets/img/icon/instagram.svg')" />
    </a>
    <a
      v-if="snsURL?.facebook"
      class="sns-icon facebook"
      :href="snsURL?.facebook"
      target="_blank"
    >
      <inline-svg :src="require('@/assets/img/icon/facebook.svg')" />
    </a>
    <a
      v-if="snsURL?.twitter"
      class="sns-icon twitter"
      :href="snsURL?.twitter"
      target="_blank"
    >
      <inline-svg :src="require('@/assets/img/icon/twitter.svg')" />
    </a>
    <a
      v-if="snsURL?.youtube"
      class="sns-icon youtube"
      :href="snsURL?.youtube"
      target="_blank"
    >
      <inline-svg :src="require('@/assets/img/icon/youtube.svg')" />
    </a>
    <a
      v-if="snsURL?.kakaotalkChannel"
      class="sns-icon kakaotalkChannel"
      :href="snsURL?.kakaotalkChannel"
      target="_blank"
    >
      <inline-svg :src="require('@/assets/img/icon/kakaotalkChannel.svg')" />
    </a>
    <a
      v-if="snsURL?.tiktok"
      class="sns-icon tiktok"
      :href="snsURL?.tiktok"
      target="_blank"
    >
      <inline-svg :src="require('@/assets/img/icon/tiktok.svg')" />
    </a>
    <a
      v-if="snsURL?.naverblog"
      class="sns-icon naverblog"
      :href="snsURL?.naverblog"
      target="_blank"
    >
      <inline-svg :src="require('@/assets/img/icon/naverblog.svg')" />
    </a>
  </div>
</template>

<script>
import InlineSvg from "vue-inline-svg";

export default {
  name: "TheSNSIcons",

  components: {
    InlineSvg,
  },

  props: {
    snsURL: {
      type: Object,
    },
  },
};
</script>
